document.addEventListener("DOMContentLoaded", function () {

  const daysEl = document.getElementById("days");
  const hoursEl = document.getElementById("hours");
  const minutesEl = document.getElementById("minutes");
  const secondsEl = document.getElementById("seconds");

  function getNextMidnightUK() {
    const now = new Date();

    const formatter = new Intl.DateTimeFormat("fr-FR", {
      timeZone: "Europe/Paris",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false
    });

    const parts = formatter.formatToParts(now);
    const get = (type) => parts.find((p) => p.type === type)?.value;

    const londonNow = new Date(
      `${get("year")}-${get("month")}-${get("day")}T${get("hour")}:${get("minute")}:${get("second")}`
    );

    const nextMidnightLondon = new Date(londonNow);
    nextMidnightLondon.setHours(24, 0, 0, 0);

    const diff = nextMidnightLondon.getTime() - londonNow.getTime();
    return new Date(Date.now() + diff);
  }

  let nextMidnight = getNextMidnightUK();

  function updateCountdown() {
    const now = new Date();
    let timeRemaining = nextMidnight - now;

    if (timeRemaining <= 0) {
      nextMidnight = getNextMidnightUK();
      timeRemaining = nextMidnight - now;
    }

    const totalSeconds = Math.floor(timeRemaining / 1000);
    const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    daysEl.textContent = "00";
    hoursEl.textContent = hours.toString().padStart(2, "0");
    minutesEl.textContent = minutes.toString().padStart(2, "0");
    secondsEl.textContent = seconds.toString().padStart(2, "0");
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
});
